'use client';

import {ExtractProps} from '@utils/typescript';
import {FC} from 'react';
import {LocaleLink, useRouter} from '.';

type IProps = Omit<
    ExtractProps<typeof LocaleLink> & {
        refresh?: boolean;
    },
    'locale'
>;

export const Link: FC<IProps> = ({
    children,
    onClick,
    prefetch = false,
    refresh = false,
    ...props
}) => {
    const router = useRouter();

    const handleClick = (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
        onClick?.(e);
        if (e.defaultPrevented) {
            return;
        }
        e.preventDefault();
        router.push(e.currentTarget.href);
        refresh && router.refresh();
    };

    return (
        <LocaleLink onClick={handleClick} prefetch={prefetch} {...props}>
            {children}
        </LocaleLink>
    );
};
